import {
  CalendarClockIcon,
  CircleCheckIcon,
  MissionIcon,
  TrendingUpIcon,
} from 'assets/icons';
import ResultTiles from 'components/stats/ResultTiles';
import { formatDateFr } from 'helper/missionInterruptDates';
import { wholeEuros } from 'pages/companies/recordItems';
import useText from 'hooks/useText';
import { RecordSection } from './RecordLayout';

/**
 * « Résultats » of the work with a company since `results.since`, a year back
 * (admin/crm/company/results): the appointments held and not held, the
 * missions it asked for and the revenue invoiced including VAT, for every CRM
 * role (decision 34). A null `invoicedRevenue` (older api) shows no revenue
 * tile, rather than a 0 that would read as no sales.
 */
const periodOf = (since, text) => {
  const start = since ? new Date(since) : null;
  // An older api sends no `since`: the period it covers is then the label's.
  if (!start || Number.isNaN(start.getTime())) return text('resultsPeriod');
  return text('resultsSince', { date: formatDateFr(since) });
};

const ResultsCard = ({ results }) => {
  const { text, plural } = useText('record');
  const count = (key, icon, value) => ({
    key,
    icon,
    value: String(value ?? 0),
    label: plural(key, value ?? 0),
  });
  const tiles = [
    count('resultsDone', CircleCheckIcon, results.appointmentsDone),
    count('resultsNotDone', CalendarClockIcon, results.appointmentsNotDone),
    count('resultsMissions', MissionIcon, results.missionsRequested),
    results.invoicedRevenue != null && {
      key: 'revenue',
      icon: TrendingUpIcon,
      value: wholeEuros(results.invoicedRevenue),
      label: text('resultsRevenue'),
    },
  ].filter(Boolean);
  return (
    <RecordSection
      title={text('results')}
      action={
        <span className="text-xs text-gray-400">{periodOf(results.since, text)}</span>
      }
    >
      <ResultTiles tiles={tiles} layout="record" />
    </RecordSection>
  );
};

export default ResultsCard;
